module.exports = __webpack_public_path__ + "img/Cursos.40bf7738.jpg";